export default __webpack_public_path__ + "static/media/ProximaNova-Bold.f3c7fec7.ttf";